module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Search",
      "append-icon": "search",
      "rules": [_vm.rules.search],
      "hint": _vm.hints.search()
    },
    on: {
      "click:append": _vm.search,
      "change": _vm.search
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.searchFor),
      callback: function($$v) {
        _vm.searchFor = $$v
      },
      expression: "searchFor"
    }
  })], 1), _vm._v(" "), (_vm.state == 'list') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "loading": _vm.loading,
      "footer-props": _vm.footerProps
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "update:items-per-page": _vm.getItemPerPage
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n            " + _vm._s(item.id) + "\n          ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.containerType))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.getValue(item.containerType, item)))]), _vm._v(" "), _c('td', [_c('router-link', {
          attrs: {
            "to": ("/parcelnumbercontainers/" + (item.id) + "/tabs/container")
          }
        }, [_vm._v("\n              Open \n            ")])], 1)])]
      }
    }], null, false, 2360341448)
  }) : _vm._e(), _vm._v(" "), (_vm.state == 'search') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "loading": _vm.loading,
      "footer-props": _vm.footerProps
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      },
      "update:items-per-page": _vm.getItemPerPage
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(item.containerType))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(_vm.getValue(item.containerType, item)))]), _vm._v(" "), _c('td', [_c('router-link', {
          attrs: {
            "to": ("/parcelnumbercontainers/" + (item.id) + "/tabs/container")
          }
        }, [_vm._v("\n              Open\n            ")])], 1)])]
      }
    }], null, false, 578722120)
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "persistent": "",
      "overlay": false,
      "max-width": "500px",
      "transition": "dialog-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "color": "success"
          }
        }, on), [_vm._v("Add")])]
      }
    }]),
    model: {
      value: (_vm.add_parcel_number_container_dialog),
      callback: function($$v) {
        _vm.add_parcel_number_container_dialog = $$v
      },
      expression: "add_parcel_number_container_dialog"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.add_parcel_number_container_dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("New Parcel Number Container")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "text": "",
      "disabled": !_vm.pncType && !_vm.pncType
    },
    on: {
      "click": function($event) {
        return _vm.savePnc()
      }
    }
  }, [_vm._v("Save")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('span', [_vm._v("Enter the Title and select a Location or Owner for the new Parcel Number Container.")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Title"
    },
    model: {
      value: (_vm.pncTitle),
      callback: function($$v) {
        _vm.pncTitle = $$v
      },
      expression: "pncTitle"
    }
  }), _vm._v(" "), _c('v-input', {
    attrs: {
      "name": "pnc_type",
      "value": _vm.pncType,
      "single-line": "",
      "messages": _vm.pncTypeMessages
    }
  }, [_c('v-expansion-panels', [_c('isrs-pnc-type-card', {
    attrs: {
      "type": "locationId",
      "itemKey": "0",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Location",
      "text": "Explore hundreds of Locations ready to connect with this Parcel Number Container! For more information visit the Unique technical manual.",
      "query": _vm.handleQueryLocations,
      "fields": ['id', 'code']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "ownerId",
      "itemKey": "1",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Owner",
      "text": "Restrict this Parcel Number Container to the following owner.",
      "query": _vm.handleQueryOwners,
      "fields": ['code', 'id']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "customerId",
      "itemKey": "2",
      "itemText": "customerName1",
      "itemValue": "customerId",
      "headline": "Customer",
      "text": "Only these customers can use this Parcel Number Container.",
      "query": _vm.handleQueryCustomers,
      "fields": ['customerName1']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "outboundOwnerId",
      "itemKey": "3",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Outbound Owner",
      "text": "Select the owner for which the outbound parcel number container shall be created.",
      "query": _vm.handleQueryOwners,
      "fields": ['code', 'id']
    },
    on: {
      "input": _vm.updateType
    }
  }), _vm._v(" "), _c('isrs-pnc-type-card', {
    attrs: {
      "type": "inboundOwnerId",
      "itemKey": "4",
      "itemText": "name",
      "itemValue": "id",
      "headline": "Inbound Owner",
      "text": "Select the owner for which the inbound parcel number container shall be created.",
      "query": _vm.handleQueryOwners,
      "fields": ['code', 'id']
    },
    on: {
      "input": _vm.updateType
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-15c2cbc2"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/ShowParcelNumberContainers.vue
// module id = 921
// module chunks = 1